import { useDrag } from 'react-dnd';
import CustomButton from '../CustomButton';

const DragableButton = ({
  column,
  icon,
  type,
  children,
  disabled,
  isPaidFeature,
}) => {
  const [, drag] = useDrag({
    item: column,
    type,
    collect: (monitor) => ({
      opacity: monitor.isDragging() ? 0.4 : 1,
      isDragging: !!monitor.isDragging(),
    }),
  });

  return (
    <CustomButton
      ref={drag}
      className="buttons"
      disabled={disabled}
      icon={icon}
      onClick={() => {}}
      isPaidFeature={isPaidFeature}
    >
      {children}
    </CustomButton>
  );
};

export default DragableButton;
